import React from 'react';
import { PhoneIcon } from '@rsos/assets/icons';
import ChatAvatar from '../ChatAvatar';
import {
  ParticipantInfo,
  ParticipantName,
  ParticipantDesc,
  PhoneNumber,
  Row,
} from './ChatParticipants.styles';

const AlertParticipant = ({ participant }) => {
  const title = participant.custom?.sender_title
    ? `${participant.custom?.sender_title} - `
    : '';
  const phone = participant.custom?.phone_number || participant.phone;

  return (
    <Row>
      {participant.name && <ChatAvatar name={participant.name} />}
      <ParticipantInfo>
        {participant.name && (
          <ParticipantName>{title + participant.name}</ParticipantName>
        )}
        {phone && (
          <ParticipantDesc>
            <PhoneIcon
              width={10}
              height={12}
              viewboxWidth={11}
              viewboxHeight={15}
              color="secondaryText"
            />
            <PhoneNumber>{phone}</PhoneNumber>
          </ParticipantDesc>
        )}
      </ParticipantInfo>
    </Row>
  );
};

export default AlertParticipant;
